
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import PanelHeader from './PanelHeader.vue'
import businessList from './DashboardBusinessList.vue'
import orderList from './DashboardOrderList.vue'
import { getCookie, setCookie, mul, getMonth } from '../../utils/publish'
import echarts from 'echarts'
  @Component({
    name: 'DashboardSale',
    components: { 
      PanelHeader, businessList, orderList
    } 
  })
  
export default class DashboardRatio extends Vue {
    tableData: any= []
    saleListData: any = []
    type = 0
    title = ''
    tableHeight: number = window.innerHeight - 200
    tableWidth: number = window.innerWidth - 270
    list:any = []
    data_type = ''
    instrumentTypes:any = []
    teacherType:any = []
    campusType:any = []
    time:any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time = ''
    end_time = ''
    groupData = [
      {
        title: 'employee_name',
        id: 'employee_name',
        label: '人员',
        width: '150',
        flag: true
      },
      {
        title: 'business_count',
        id: 'business_count',
        label: '销售总数',
        width: '100',
        flag: false
      },
      {
        title: 'order_count',
        id: 'order_count',
        label: '成单总数',
        width: '100',
        flag: false
      },
      {
        title: 'order_ratio',
        id: 'order_ratio',
        label: '销售转化率',
        width: '100',
        flag: false
      },
      {
        title: 'total_price',
        id: 'total_price',
        label: '销售成单业绩（元）',
        width: '150',
        flag: true
      },
      {
        title: 'avg_price',
        id: 'avg_price',
        label: '均价（元）',
        width: '100',
        flag: true
      },
      {
        title: 'benyue_order_count',
        id: 'benyue_order_count',
        label: '本月销售且成单数',
        width: '150',
        flag: false
      },
      {
        title: 'benyue_order_ratio',
        id: 'benyue_order_ratio',
        label: '本月销售成功转换率',
        width: '150',
        flag: false
      },
      {
        title: 'benyue_total_price',
        id: 'benyue_total_price',
        label: '本月销售且成单业绩（元）',
        width: '180',
        flag: true
      },
      {
        title: 'benyue_avg_price',
        id: 'benyue_avg_price',
        label: '均价（元）',
        width: '150',
        flag: true
      },
      {
        title: 'un_benyue_order_count',
        id: 'un_benyue_order_count',
        label: '非本月销售且成单数',
        width: '150',
        flag: false
      },
      {
        title: 'un_benyue_order_ratio',
        id: 'un_benyue_order_ratio',
        label: '非本月销售成功转化率',
        width: '150',
        flag: false
      },
      {
        title: 'un_benyue_total_price',
        id: 'un_benyue_total_price',
        label: '非本月销售且成单业绩（元）',
        width: '180',
        flag: true
      },
      {
        title: 'un_benyue_avg_price',
        id: 'un_benyue_avg_price',
        label: '均价（元）',
        width: '100',
        flag: true
      },
      {
        title: 'benyue_un_shiting_order_count',
        id: 'benyue_un_shiting_order_count',
        label: '本月非试听且成单数',
        width: '150',
        flag: false
      },
      {
        title: 'benyue_un_shiting_order_ratio',
        id: 'benyue_un_shiting_order_ratio',
        label: '本月非试听成功转换率',
        width: '150',
        flag: false
      },
      {
        title: 'benyue_un_shiting_total_price',
        id: 'benyue_un_shiting_total_price',
        label: '本月非试听且成单业绩（元）',
        width: '180',
        flag: true
      },
      {
        title: 'benyue_un_shiting_avg_price',
        id: 'benyue_un_shiting_avg_price',
        label: '均价（元）',
        width: '100',
        flag: true
      },
      {
        title: 'total_price',
        id: 'total_price1',
        label: '总业绩（元）',
        width: '100',
        flag: false
      },
      {
        title: 'avg_price',
        id: 'avg_price1',
        label: '总均价（元）',
        width: '100',
        flag: true
      }
    ]
    tabPosition: any = ''
    tabType: any = ''
    employee_id: any = ''
    ages: any = []
    source: any = []
    loading: boolean = false
    lineShow: boolean = false
    showTeacher: boolean = false
    isBusiness: boolean = false
    isOrder: boolean = false
    positionType: boolean = false
    isGetTime: boolean = false
    showSource: boolean = true
    listPage: any = {
      page: 1,
      size: 10,
      total_count: 0
    }
    months = [
      {
        flag: false,
        id: '01'
      },
      {
        flag: false,
        id: '02'
      },
      {
        flag: false,
        id: '03'
      },
      {
        flag: false,
        id: '04'
      },
      {
        flag: false,
        id: '05'
      },
      {
        flag: false,
        id: '06'
      },
      {
        flag: false,
        id: '07'
      },
      {
        flag: false,
        id: '08'
      },
      {
        flag: false,
        id: '09'
      },
      {
        flag: false,
        id: '10'
      },
      {
        flag: false,
        id: '11'
      },
      {
        flag: false,
        id: '12'
      }
    ]

    getHeight() {
      window.onresize = () =>{
        this.tableHeight = window.innerHeight - 200
      }
    }
    getSelectChange(val: any) {
      if(!this.tabPosition) {
        const property = this.$route.query.property
        this.getProperty(property)
      }
      this.employee_id = this.$route.query.employee_id
      this.getCookieData()
      if (this.employee_id) { // 有老师
        this.getSaleList('')
      } else {  // 全部
        this.getSaleList(1)
      }
      this.yearSaleList()
      this.getDetailsList()
      this.isGetTime = false
    }
    handleClick(val) {
      this.getProperty(val)
      if (this.tabPosition.indexOf('_ratio') >= 0) {
        this.positionType = true
      } else {
        this.positionType = false
      }
      for (var i = 0; i < this.months.length; i++) {
        this.months[i].flag = false
      }
      this.yearSaleList()
      this.isBusiness = false
      this.isOrder = false
      this.getDetailsList()
    }

    getNowMonth(type, months, year, month) {
      return getMonth(type, months, year, month)
    }

    getGoodTime(time, type) {
      const t = Date.parse(<any> new Date(time))
      let day: any = ''
      if (type === 1) { // 开始时间
        day = t - 8 * 60 * 60 * 1000
      } else if (type === 2) { // 结束时间
        day = t + 16 * 60 * 60 * 1000 - 1000
      }
      return new Date(day)
    }
    drawLine(yearList, dataList){
      const that = this
      // 基于准备好的dom，初始化echarts实例
      let dom:any = document.getElementById('myChart')
      let myChart:any = echarts.init(dom)
      
      //防止重复触发点击事件
      if(myChart._$handlers.click){
          myChart._$handlers.click.length = 0;
      }
      myChart.on('click', function (params) {
        const day = params.name
        if (!day) {
          return false
        }
        const year = day.split('/')[0]
        const month = day.split('/')[1]
        let start:any = that.getNowMonth('s', 0, year, month)
        let end:any = that.getNowMonth('e', 0, year, month)
        start = that.getGoodTime(start, 1)
        end = that.getGoodTime(end, 2)
        const time = [start, end]
        setCookie('time', JSON.stringify(time), 1)
        that.isGetTime = true
      })
      // 绘制图表
      myChart.setOption({
        title: {
          text: '',
          textStyle:{
            color:'#333',
          }
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: yearList,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '50%',
            data: dataList,
            itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#333'
									}
								}
							}
						},
          }
        ]
      });
    }

    drawLine1(yearList, dataList){
      const that = this
      // 基于准备好的dom，初始化echarts实例
      let dom:any = document.getElementById('myChart1')
      let myChart = echarts.init(dom)
      myChart.on('click', function (params) {
        const day = params.name
        if (!day) {
          return false
        }
        const year = day.split('/')[0]
        const month = day.split('/')[1]
        let start:any = that.getNowMonth('s', 0, year, month)
        let end:any = that.getNowMonth('e', 0, year, month)
        start = that.getGoodTime(start, 1)
        end = that.getGoodTime(end, 2)
        const time = [start, end]
        setCookie('time', JSON.stringify(time), 1)
        that.isGetTime = true
      })
      // 绘制图表
      myChart.setOption({
        title: {
          text: '',
          textStyle:{
            color:'#333',
          }
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter:'{c}%'　　　　//这是关键，在需要的地方加上就行了
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: yearList,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '50%',
            data: dataList,
            itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#333'
                  },
                  formatter: '{c}%'　　　　//这是关键，在需要的地方加上就行了
								}
							}
						},
          }
        ]
      });
    }
    
    async yearSaleList() {
      const res = await UserModule.yearSale({ field_name: this.tabPosition, data_type: 1, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.employee_id, start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString(), source: this.source.toString()})
      if(res.data.length === 0) {
        this.lineShow = false
        return false
      }
      this.lineShow = true
      let year = ''
      if(res.data[0].months) {
        year = res.data[0].months.substring(0, 4)
      } else {
        year = ''
      }
      const yearData = res.data
      for (var m = 0; m < this.months.length; m++) {
        this.months[m]['flag'] = false
      }
      for (var i = 0; i < this.months.length; i++) {
        for(var j = 0; j < res.data.length; j++) {
          const str = res.data[j].months
          if (this.months[i].id === str.substring(str.length - 2)) {
            this.months[i].flag = true
          }
        }
      }
      let obj = {}
      obj[this.tabPosition] = 0
      for (var k = 0; k < this.months.length; k++) {
        if (!this.months[k].flag) {
          yearData.splice(k, 0, obj);
        }
      }
      const yearList = []
      const dataList = []
      for (var i = 0; i < this.months.length; i++) {
        yearList.push(year + '/' + this.months[i].id)
        let it = yearData[i][this.tabPosition]
        if(!it) {
          it = 0
        }
        if (this.positionType) {
          dataList.push(this.getMul(it, 100))
        } else {
          dataList.push(it)
        }
      }
      if (this.positionType) {
        this.drawLine1(yearList, dataList)
      } else {
        this.drawLine(yearList, dataList)
      }
    }
    getMul(val1, val2) {
      return mul(val1, val2)
    }
    getDetailsList() {
      for (var i = 0; i < this.groupData.length; i++) {
        if (!this.groupData[i].flag && this.tabPosition === this.groupData[i].title) {
          this.saleDetailsList()
        }
      }
    }
    async getSaleList(val) {
      const res = await UserModule.saleList({ is_total: val, data_type: 1, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.employee_id, start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString(), source: this.source.toString()})
      this.tableData = res.data
      if(this.tableData.length > 0) {
        this.loading = true
      } else {
        this.loading = false
      }
    }

    async saleDetailsList() {
      if (this.tabPosition === 'business_count' || this.tabPosition === 'order_ratio' || this.tabPosition === 'benyue_order_ratio' || this.tabPosition === 'un_benyue_order_ratio' || this.tabPosition === 'benyue_un_shiting_order_ratio' ) { // 商机
        this.isBusiness = true
        this.isOrder = false
      } else { // 订单
        this.isBusiness = false
        this.isOrder = true
      }
      const res = await UserModule.saleDetailList({ field_name: this.tabPosition, data_type: 1, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.employee_id, start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString(), source: this.source.toString(), page: this.listPage.page, size: this.listPage.size})
      this.saleListData = res.data.list
      this.listPage.total_count = res.data.total
    }
    handlePageChange(val) {
      this.listPage.page = val.page
      this.saleDetailsList()
    }

    getCookieData() {
      this.instrumentTypes = JSON.parse(getCookie('instrumentTypes'))
      this.teacherType = JSON.parse(getCookie('teacherType'))
      this.campusType = JSON.parse(getCookie('campusType'))
      this.source = JSON.parse(getCookie('source')) 
      this.ages = JSON.parse(getCookie('ages'))
      this.time = JSON.parse(getCookie('time'))
      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
    }

    getProperty(val) {
      for (var i = 0; i < this.groupData.length; i++) {
        if (val === this.groupData[i].id) {
          this.tabPosition = this.groupData[i].title
          this.tabType = this.groupData[i].id
        }
      }
    }
    mounted() {
      const property = this.$route.query.property
      this.getProperty(property)
      this.employee_id = this.$route.query.employee_id
      if (this.tabPosition.indexOf('_ratio') >= 0) {
        this.positionType = true
      } else {
        this.positionType = false
      }
      this.getCookieData()
      this.getHeight()
      if (this.employee_id) { // 有老师
        this.getSaleList('')
      } else {  // 全部
        this.getSaleList(1)
      }
      this.yearSaleList()
      this.getDetailsList()
    }
  }
